export default __webpack_public_path__ + "static/media/cs-block-1.bb512556.png";